import React from "react";

export const TRAVELER_INFO_TITLE = "Step 1. Traveler Information";
export const TRAVELER_INFO_TITLE_UPDATED = "Select or add travelers";
export const TRAVELER_INFO_SUBTITLE = (
  <>
    <strong>
      The number of travelers you select cannot exceed the max occupancy of your
      chosen room.
    </strong>{" "}
    Make sure the information you add matches each traveler’s ID. You can’t
    change this information after booking.
  </>
);
export const FREQUENT_FLYER_TITLE = "Frequent Flyer details";
export const FREQUENT_FLYER_SUBTITLE =
  "You can add an unlimited amount of Frequest Flyer programs to each traveler.";
export const ADDITIONAL_INFO_TITLE = "Additional information";
export const ADULT_TITLE = "Adult";
export const CHILD_TITLE = "Child";
export const INFANT_SEAT_TITLE = "Infant";
export const INFANT_LAP_TITLE = "Infant";
export const UPDATE_TEXT = "Updating passengers";
export const VALIDATE_TEXT = "Validating passengers";
export const ADD_TRAVELERS_TEXT = "Add travelers";
export const ADD_TRAVELERS_TEXT_UPDATED = "Add new traveler";
export const EDIT_TRAVELER_TEXT = "Edit traveler";
export const ADD_TRAVELERS_SUBTITLE =
  "Ensure all information matches your travel ID. You can't change this information once you place a booking.";
export const ADD_TRAVELER_INFO_TEXT = "Add traveler information";
export const TRAVELER_INFO_TEXT = "Traveler information";
export const ADD_TRAVELER_ERROR_MESSAGE =
  "Add or choose at least one traveler to continue.";
export const PASSPORT_TITLE = "Passport details";
export const PASSPORT_SUBTITLE =
  "Certain airlines may require you to submit your passport information on international flights.";
export const PASSPORT_SUBTITLE_2 =
  "All fields must be completed to be saved successfully.";
export const WHOS_FLYING_HEADING = "Who’s flying?";
export const WHOS_FLYING_HEADING_V1 = "1. Who's flying?";
export const MOBILE_CONTINUE_TEXT = "Add primary traveler";

// corporate
export const COMPLETE_PROFILE_TITLE = "Complete traveler profile";
export const COMPLETE_PROFILE_SUBTITLE =
  "Please make sure all the information added matches the government issued ID for this traveler as this will be applied to travel bookings moving forward. Traveler information will be accessible to all Admins.";
